// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"ee3964ae","126":"f98f1f53","171":"9333fc32","698":"abce6718"}[chunkId] + ".chunk.js";
};